/* eslint-disable no-undef */
import { createSlice } from "@reduxjs/toolkit";
import stepsConfig from "../components/WalkthroughSteps/WalkthroughSteps";

const calculateMiddleCell = (rowCount, colCount) => {
  const middleX = Math.floor(colCount / 2);
  const middleY = Math.floor(rowCount / 2);
  console.log(`Calculated middle cell: #cell_${middleX}_${middleY} for grid size ${rowCount}x${colCount}`);
  return `#cell_${middleY}_${middleX}`;
};

const configureWelcomeStep = (step, rowCount, colCount) => {
  if (step.key !== "welcome") {
    return step;
  }

  const isSmallScreen = window.innerWidth < 1250;
  return {
    ...step,
    target: rowCount > 2 && colCount > 2 && !isSmallScreen ? calculateMiddleCell(rowCount, colCount) : `#gridd_content`,
    placement: rowCount > 3 && colCount > 3 && !isSmallScreen ? "right" : "center",
  };
};

const initialState = {
  run: false,
  stepIndex: 0,
  rowCount: 0,
  colCount: 0,
  steps: stepsConfig,
  savedStepIndex: 0,
};

const joyrideSlice = createSlice({
  name: "joyride",
  initialState,
  reducers: {
    startJoyride: (state, action) => {
      const { rowCount, colCount } = action.payload;
      state.rowCount = rowCount;
      state.colCount = colCount;
      state.steps = stepsConfig.map((step) => configureWelcomeStep(step, rowCount, colCount));
      state.run = true;
      state.stepIndex = 0;
    },
    stopJoyride: (state) => {
      state.run = false;
      state.stepIndex = 0;
      state.targetCell = null;
      state.steps = [];
    },
    nextStep: (state) => {
      if (state.stepIndex < state.steps.length - 1) {
        state.stepIndex += 1;
      } else {
        state.run = false;
        state.stepIndex = 0;
        state.targetCell = null;
        state.steps = [];
      }
    },
    prevStep: (state) => {
      if (state.stepIndex > 0) {
        state.stepIndex -= 1;
      }
    },
    showDownloadStep: (state) => {
      state.savedStepIndex = state.stepIndex;
      const currentStep = state.steps[state.stepIndex];
      const currentTarget = currentStep?.target;
      const currentPlacement = currentStep?.placement;
      state.run = true;
      state.stepIndex = 0;
      state.steps = [
        {
          key: "download",
          target: currentTarget,
          title: "Downloading...",
          content: "download",
          disableBeacon: true,
          placement: currentPlacement,
        },
      ];
    },
    resumeFromDownload: (state) => {
      const { rowCount, colCount } = state;
      state.stepIndex = state.savedStepIndex;
      state.steps = stepsConfig.map((step) => configureWelcomeStep(step, rowCount, colCount));
      state.run = true;
    },
  },
});

export const { startJoyride, stopJoyride, nextStep, prevStep, showDownloadStep, resumeFromDownload } =
  joyrideSlice.actions;

export default joyrideSlice.reducer;
